import { render, staticRenderFns } from "./customsInfoDialog.vue?vue&type=template&id=1408a65a&"
import script from "./customsInfoDialog.vue?vue&type=script&lang=js&"
export * from "./customsInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1408a65a')) {
      api.createRecord('1408a65a', component.options)
    } else {
      api.reload('1408a65a', component.options)
    }
    module.hot.accept("./customsInfoDialog.vue?vue&type=template&id=1408a65a&", function () {
      api.rerender('1408a65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/customsInfoDialog.vue"
export default component.exports